<script setup lang="ts">
import { computed } from 'vue'

import { useI18n } from '@/app/i18n'
import { ROUTE_PROFILE } from '@/app/router/names'
import { logout } from '@/app/session'
import { useAuthStore } from '@/app/stores/auth'
import AppAvatar from '@/shared/ui/AppAvatar.vue'
import AppDropdownActions from '@/shared/ui/AppDropdownActions.vue'
import { personInitials } from '@/shared/utils/initials'

/**
 * The user menu (wp/shell §4.17): "Hello, <first name>" (hidden on phones) and the avatar with the green dot; "Profile"
 * and "Logout" — the one logout that stops the polling and deletes the session (NEW-1).
 */
const { t } = useI18n()
const auth = useAuthStore()
const profile = computed(() => auth.session?.profile)
const firstName = computed(() => (typeof profile.value?.FirstName === 'string' ? profile.value.FirstName : ''))
const items = computed(() => [
  { id: 'profile', label: t('common.nav.profile'), icon: 'UserIcon', to: { name: ROUTE_PROFILE } },
  { id: 'logout', label: t('common.action.logout'), icon: 'LogOutIcon', onSelect: () => void logout() },
])
</script>

<template>
  <AppDropdownActions :label="t('shell.navbar.action.userMenu')" :items="items" data-testid="user-menu">
    <template #trigger="{ toggle }">
      <button
        type="button"
        class="flex items-center gap-3"
        :aria-label="t('shell.navbar.action.userMenu')"
        @click="toggle"
      >
        <span class="hidden font-semibold text-heading sm:inline" data-testid="user-greeting">
          {{ t('shell.navbar.hint.hello') }}, {{ firstName }}
        </span>
        <AppAvatar
          :src="profile?.ImageUrl ?? null"
          :text="personInitials(profile?.FirstName, profile?.LastName)"
          :size="40"
          badge="success"
        />
      </button>
    </template>
  </AppDropdownActions>
</template>
